import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function ChangePassword() {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError('New password and confirm password do not match.');
      return;
    }
    if (newPassword.length < 8) {
      setError('New password must be at least 8 characters long.');
      return;
    }
    // Simulate password change API call
    setSuccess('Password changed successfully!');
    setError('');
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
  };

  return (
    <div className="content-wrapper">
      <div className="page-title">
        <div className="container">
          <h4 className="breadcrumb">
            <span className="breadcrumb-link" onClick={() => navigate('/')}>Home</span>
            <span className="breadcrumb-separator"> / </span>
            <span className="breadcrumb-link" onClick={() => navigate('/account')}>Your Account</span>
            <span className="breadcrumb-separator"> / </span>
            <span className="breadcrumb-current">Change Password</span>
          </h4>
        </div>
      </div>

      <section className="change-password">
        <div className="container">
          <h2>Change Password</h2>
          <div className="password-form-card">
            {error && <p className="error-message">{error}</p>}
            {success && <p className="success-message">{success}</p>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="current-password">Current Password</label>
                <input
                  type="password"
                  id="current-password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="new-password">New Password</label>
                <input
                  type="password"
                  id="new-password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirm-password">Confirm New Password</label>
                <input
                  type="password"
                  id="confirm-password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="submit-btn">Change Password</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ChangePassword;